export const nodeIds = {
    TRIGGER: '35fe5cad-81ad-5957-a088-fffe69c024b0',
    SPLIT_OUT_POST_URLS: '6e4fc74d-d93f-52be-addf-5bed3d21260e',
    SCRAPE_BLOG_POST_PAGE: '4a5bbc57-a813-585c-bfbb-de01d403dda6',
    EXTRACT_BLOG_POST_CONTENT: '84bb5ad7-7618-5b7d-bfe5-8c0b82539033',
    CLASSIFY_BLOG_POST_TYPE: 'b6843872-8c95-52b3-8849-d4ea28e9c134',
    AGGREGATE_POSTS: '0c515174-c2e2-57ac-8451-a3cb6bfcdc06',
    BLOG_POST_OUTLINE_STRATEGIZER: '1da8854f-4571-5df7-a426-c1dfeb1fba8a'
};

export const nodes = [
    {
        "id": "35fe5cad-81ad-5957-a088-fffe69c024b0",
        "type": "workflow_module",
        "action": "manual_trigger",
        "credentials": [],
        "display_name": "Scheduled Trigger",
        "description": "Starts the workflow at a set schedule or manually when needed.",
    },
    {
        id: 'ff5b67b5-7aba-502f-9557-93e4ce9b9c7d',
        type: 'app_action',
        action: 'split_out_primary_keywords',
        app: 'blog_post_content_strategizer',
        credentials: [],
        display_name: 'Split out primary keywords',
        description: 'Takes a list of primary keywords and breaks them into individual keywords.'
    },
    {
        id: '4a696074-ac5f-51d7-afc7-4ebf21693d9f',
        type: 'app_action',
        action: 'scrape_google_search_results',
        app: 'web_scrape',
        credentials: [],
        display_name: 'Get Google search results',
        description: 'Fetches top blog post URLs from Google search results for each primary keyword.'
    },
    {
        id: '048c3635-65ff-5fed-b0c0-8310735a0b8f',
        type: 'app_action',
        action: 'extract_blog_post_urls',
        app: 'blog_post_content_strategizer',
        credentials: [],
        display_name: 'Extract blog post URLs',
        description: 'Parses Google search results to extract blog post URLs.'
    },
    {
        "id": "6e4fc74d-d93f-52be-addf-5bed3d21260e",
        "app": "blog_post_content_strategizer",
        "type": "app_action",
        "action": "split_out_post_urls",
        "credentials": [],
        "display_name": "Split out post URLs",
        "description": "Takes a list of blog post links and breaks them into individual URLs.",
    },
    {
        "id": "4a5bbc57-a813-585c-bfbb-de01d403dda6",
        "app": "web_scrape",
        "type": "app_action",
        "action": "scrape_website",
        "credentials": [],
        "display_name": "Scrape webpage",
        "description": "Fetches the HTML and content from each provided blog post URL.",
    },
    {
        "id": "84bb5ad7-7618-5b7d-bfe5-8c0b82539033",
        "app": "blog_post_content_strategizer",
        "type": "app_action",
        "action": "blog_post_content_extractor",
        "credentials": [],
        "display_name": "Extract blog post content",
        "description": "Parses scraped HTML to extract the main blog post text and metadata."
    },
    {
        "id": "b6843872-8c95-52b3-8849-d4ea28e9c134",
        "app": "blog_post_content_strategizer",
        "type": "app_action",
        "action": "blog_post_classifier",
        "credentials": [],
        "display_name": "Classify blog post type",
        "description": "Analyzes extracted content to categorize the blog post."
    },
    {
        "id": "0c515174-c2e2-57ac-8451-a3cb6bfcdc06",
        "app": "blog_post_content_strategizer",
        "type": "app_action",
        "action": "aggregate_posts",
        "config": {
            "batch": {
                "size": 9007199254740991
            }
        },
        "credentials": [],
        "display_name": "Aggregate posts",
        "description": "Combines processed blog posts into a single dataset."
    },
    {
        "id": "1da8854f-4571-5df7-a426-c1dfeb1fba8a",
        "app": "blog_post_content_strategizer",
        "type": "app_action",
        "action": "blog_post_content_strategy_generator",
        "credentials": [],
        "display_name": "Blog post content strategizer",
        "description": "Generates actionable content strategies based on aggregated posts."
    },
    {
        "id": "1da8854f-4571-5df7-a426-c1dfeb1fba8a",
        "app": "blog_post_content_strategizer",
        "type": "app_action",
        "action": "blog_post_content_strategy_refiner",
        "credentials": [],
        "display_name": "Blog post content refiner",
        "description": "Refines and enhances the initial content strategy with additional insights."
    },
    {
        id: '2ab33081-c633-5390-bba7-c2452ab386a0',
        type: 'app_action',
        app: 'google_docs',
        action: 'GOOGLEDOCS_CREATE_DOCUMENT_MARKDOWN',
        credential: [],
        display_name: 'Create Google Doc',
        description: 'Creates a Google Doc with the generated content strategy in markdown format.'
    }
];


export enum KeyValEntityType {
    TASKS_TODO_BUCKET = 'TASKS_BPCS_TODO',
    TASKS_IN_PROGRESS_BUCKET = 'TASKS_BPCS_IN_PROGRESS',
    TASKS_WAITING_FOR_APPROVAL_BUCKET = 'TASKS_BPCS_WAITING_FOR_APPROVAL',
    TASKS_COMPLETED_BUCKET = 'TASKS_BPCS_COMPLETED',
    TASKS_FAILED_BUCKET = 'TASKS_BPCS_FAILED',
    TASKS_DRAFT_GENERATING_BUCKET = 'TASKS_BPCS_DRAFT_GENERATING',
    TASKS_DRAFT_GENERATED_BUCKET = 'TASKS_BPCS_DRAFT_GENERATED',
}

// TODO: change this to proper name
export const APP_NAME = 'kv_task_queue'

// Node ID for fetching the markdown output
export const TARGET_NODE_ID = 'd0d2dcbf-7b9c-53f2-ac0f-24dbd513b41b'

const BASE_PATH = '/ui/agent/blog-post-content-strategizer'

export const ROUTES = {
    BASE: BASE_PATH,
    OUTPUT: `${BASE_PATH}/output`,
    result: (workflowExecutionId: string) => `${BASE_PATH}/result/${workflowExecutionId}`,
} as const
